import { Page } from "./Page.tsx"

export function App() {
  return <Page />
}
